import React from 'react';
import classes from "./payment.module.scss"
import cx from "classnames"
import { Icon } from 'lb-components';
import { ErrorIcon, SuccessIcon } from './icon/icons';
import { useTranslation } from 'lb-store';
import { Button } from 'react-bootstrap';
const PaymentStatus =({msg,status})=>{
  const { t } = useTranslation()

    return  (<div className={classes.paymentStatus}>
        <div className={classes.pay_container}>

            <div >
                <Icon
                  Icon={status==='success'?SuccessIcon:ErrorIcon}
                  classname={classes.paymentStatusIcon}
                />
            </div>
            <div>
              <span className={cx(classes.paymentStatusText,{
                [classes.success]:status==='success',
                [classes.error]:status==='error'
              })}>
                {
                  status==='success'?t(msg?msg:"ვერიფიკაცია წარმატებით დასრულდა"):t(msg?msg:'დაფიქსირდა შეცდომა')
                }
              </span>

            </div>
          <div style={{marginTop:20}}>
            <Button variant="primary" onClick={()=> window.top.location="/"}> {t("დახურვა")} </Button>
          </div>

        </div>
    </div>)
}
 export default PaymentStatus;
